import { h } from '@stencil/core';

const CULLABLE = 'cullable';
const createCullableNode = (cullNode, utils) => {
    return utils.map([h("div", null)], (node) => (Object.assign(Object.assign({}, node), { vtag: null, vattrs: Object.assign(Object.assign({}, node.vattrs), { cull: cullNode }), vtext: '\n', vname: CULLABLE })));
};
const cullDecendants = (children, utils) => {
    utils.forEach(children, (child) => {
        var _a, _b;
        if (child.vname === CULLABLE) {
            (_b = (_a = child.vattrs) === null || _a === void 0 ? void 0 : _a.cull) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        if (child.vchildren) {
            cullDecendants(child.vchildren, utils);
        }
    });
};

export { createCullableNode, cullDecendants };
